export default __webpack_public_path__ + "static/media/834.38b8aefb.png";